export async function generateField({
  fieldLabel,
  fieldKey,
  entityType,
  entity,
  extraContext,
  projectContext,
  apiKey,
}) {
  if (!apiKey) {
    throw new Error('OpenAI API key is required. Please add your API key in settings.')
  }

  const res = await fetch('/api/ai/generate-field', {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'X-OpenAI-API-Key': apiKey,
    },
    body: JSON.stringify({
      fieldLabel,
      fieldKey,
      entityType,
      entity,
      extraContext,
      projectContext,
    }),
  })

  const data = await res.json().catch(() => ({}))

  if (!res.ok) {
    const message = data?.message || data?.error || `AI request failed (${res.status})`
    const err = new Error(message)
    err.status = res.status
    err.details = data
    throw err
  }

  return data?.text || ''
}


